import { api } from "./client";

export type Me = {
  id: number;
  email: string;
  name: string;
  department: string | null;
  role: "ADMIN" | "MANAGER" | "VIEWER";
  status: "PENDING" | "APPROVED" | "REJECTED";
  scoped_departments: string[];
};

export const authApi = {
  me: () => api.get<Me>("/auth/google/me"),
  googleStartUrl: "/api/v1/auth/google/start",
  logout: () => api.post<void>("/auth/google/logout"),
};
